import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {fetchUser, registerUser} from "../redux/actions/user";
import {setMessage} from "../redux/actions/status";

import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert,
    Button,
    Modal
} from "react-bootstrap";
import { Link } from "react-router-dom";

import bgImage from "assets/img/pharmacy.jpg";
import { firestore } from "../config/firebase";
import professionalsData from "../json/professionals.json";


class Registration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            telephone: '',
            profession:'',
            numero:'',
            email: '',
            password: '',
            confirmPassword: '',
            showPassword: false,
            showConfirmPassword: false,
            showPrivacyModal: false,
            cardHidden: true,
            registrationInProgress: false,
            validatingProfessional: false
        };
    }

    componentDidMount() {
        setTimeout(() => this.setState({ cardHidden: false }), 700);
    }

    setValue = (val, index) => {
        let newState = {};
        newState[index] = val;
        this.setState(newState);
    };

    togglePasswordVisibility = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
    };

    findProfessionalInJsonFile = (numeroUpper, cleanNumero) => {
        try {
            const found = professionalsData.find(prof => {
                const dbNumero = prof['Nº D\'INSCRIPTION'] || prof.numero || prof.registrationNumber || prof.id;

                if (!dbNumero) return false;

                const dbNumeroUpper = dbNumero.toString().toUpperCase().trim();
                const cleanDbNumero = dbNumeroUpper.replace(/[-\s]/g, '');

                // Comparaison exacte OU nettoyée
                return dbNumeroUpper === numeroUpper || cleanDbNumero === cleanNumero;
            });

            if (found) {
                return {
                    name: found['NOM PRENOMS'] || found.name || found.nom || '',
                    numero: found['Nº D\'INSCRIPTION'] || found.numero || '',
                    structure: found['STRUCTURE'] || found.structure || found.etablissement || '',
                    section: found['SECTION'] || found.section || found.type || ''
                };
            }

            return null;
        } catch (error) {
            console.error('Erreur lors de la recherche dans le fichier JSON:', error);
            return null;
        }
    };

    findProfessionalInFirebase = async (numeroUpper, cleanNumero) => {
        try {
            const snapshot = await firestore.collection('professionals').get();
            let found = null;

            snapshot.forEach(doc => {
                const prof = doc.data();

                // Chercher dans tous les formats possibles de numéro d'inscription
                const dbNumero = prof.registrationNumber ||
                               prof.id ||
                               prof['Nº D\'INSCRIPTION'] ||
                               prof.numero_enregistrement ||
                               prof.numero;

                if (!dbNumero) return;

                const dbNumeroUpper = dbNumero.toString().toUpperCase().trim();
                const cleanDbNumero = dbNumeroUpper.replace(/[-\s]/g, '');

                // Comparaison exacte OU nettoyée
                const exactMatch = dbNumeroUpper === numeroUpper;
                const cleanMatch = cleanDbNumero === cleanNumero;

                if (exactMatch || cleanMatch) {
                    found = {
                        name: prof.name || prof['NOM PRENOMS'] || prof.nom || '',
                        numero: dbNumero,
                        structure: prof.structure || prof['STRUCTURE'] || prof.etablissement || '',
                        section: prof.section || prof['SECTION'] || prof.type || ''
                    };
                }
            });

            return found;
        } catch (error) {
            console.error('Erreur lors de la recherche Firebase:', error);
            return null;
        }
    };

    validateNumeroWithDatabase = async (numero) => {
        const numeroUpper = numero.toUpperCase().trim();

        // Nettoyer le numéro (supprimer espaces, tirets, etc.)
        const cleanNumero = numeroUpper.replace(/[-\s]/g, '');

        // 1. Chercher d'abord dans Firebase
        let found = await this.findProfessionalInFirebase(numeroUpper, cleanNumero);

        // 2. Si non trouvé dans Firebase, chercher dans le fichier JSON
        if (!found) {
            found = this.findProfessionalInJsonFile(numeroUpper, cleanNumero);
        }

        if (found) {
            return {
                isValid: true,
                message: `Numéro d'ordre validé. Professionnel: ${found.name}`,
                professional: found
            };
        } else {
            return {
                isValid: false,
                message: `Numéro "${numero}" non trouvé dans la base de données des professionnels. Veuillez vérifier le numéro.`
            };
        }
    };

    onSubmit = async (event) => {
        event.preventDefault();

        const { name, telephone, profession, numero, email, password, confirmPassword } = this.state;

        // Validation des champs obligatoires
        if (!password || !email || !name || !numero || !profession || !telephone) {
            this.props.setMessage({message: 'Tous les champs sont obligatoires.', status: 'danger'});
            return;
        }

        // Validation de la confirmation du mot de passe
        if (password !== confirmPassword) {
            this.props.setMessage({message: 'Les mots de passe ne correspondent pas.', status: 'danger'});
            return;
        }

        // Indiquer que la validation est en cours
        this.setState({ validatingProfessional: true });

        // Validation du numéro d'ordre avec Firebase et le fichier JSON
        const dbValidation = await this.validateNumeroWithDatabase(numero);
        this.setState({ validatingProfessional: false });

        if (!dbValidation.isValid) {
            this.props.setMessage({message: dbValidation.message, status: 'danger'});
            return;
        }

        // Validation de l'email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            this.props.setMessage({message: 'Veuillez entrer une adresse email valide.', status: 'danger'});
            return;
        }

        // Validation du mot de passe
        if (password.length < 6) {
            this.props.setMessage({message: 'Le mot de passe doit contenir au moins 6 caractères.', status: 'danger'});
            return;
        }

        this.setState({ registrationInProgress: true });

        // Si toutes les validations passent, on enregistre
        this.props.registerUser({
            name: name.trim(),
            telephone: telephone.trim(),
            profession: profession.trim(),
            numero: numero.trim(),
            email: email.trim().toLowerCase(),
            password
        });

        // Afficher le message de succès avec les informations du professionnel
        this.props.setMessage({
            message: `Inscription réussie ! ${dbValidation.message}`,
            status: 'success'
        });

        this.setState({ registrationInProgress: false });
    }

    render() {
        const { showPassword, showConfirmPassword, registrationInProgress, validatingProfessional } = this.state;

        return (
            <div style={styles.page}>
                <style>
                    {`
                        @media (max-width: 767px) {
                            .registration-image-panel {
                                display: none !important;
                            }
                        }
                        .registration-form .form-control {
                            height: 50px;
                        }
                    `}
                </style>
                <Grid fluid style={styles.registrationGrid}>
                    <Row>
                        <Col xs={12}>
                            <div
                                className="panel panel-default"
                                style={{
                                    ...styles.registrationContainer,
                                    opacity: this.state.cardHidden ? 0 : 1,
                                    transform: this.state.cardHidden ? "translateY(15px)" : "translateY(0)"
                                }}
                            >
                                <div
                                    className="registration-image-panel"
                                    style={{
                                        ...styles.imagePanel,
                                        backgroundImage: `url(${bgImage})`
                                    }}
                                >
                                    <div style={styles.imageOverlay}>
                                        <div style={styles.logoCircle}>
                                            <i className="fa fa-medkit" />
                                        </div>
                                        <div>
                                            <h1 style={styles.imageTitle}>APURMED</h1>
                                            <p style={styles.imageSubtitle}>
                                                Votre solution numérique pour la gestion pharmaceutique
                                            </p>
                                        </div>
                                        <div style={styles.imageBottom}>
                                            <div><i className="fa fa-shield" /> <span>Inscription sécurisée</span></div>
                                            <div><i className="fa fa-user-md" /> <span>Réservé aux professionnels de santé</span></div>
                                            <div><i className="fa fa-check-circle" /> <span>Validation du numéro d'ordre</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div style={styles.formPanel}>
                                    <div style={styles.formInner}>
                                        <form className="registration-form" onSubmit={this.onSubmit}>
                                            <div className="panel-heading" style={styles.formHeader}>
                                                <h2 style={styles.formTitle}>Créer un compte</h2>
                                                <p style={styles.formSubtitle}>Inscription professionnelle LINFOMED</p>
                                            </div>
                                            <div className="panel-body" style={styles.formBody}>
                                                    {this.props.message && (
                                                        <Alert bsStyle={this.props.message.status} style={{
                                                            marginBottom: '20px',
                                                            borderRadius: '8px',
                                                            border: 'none',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                        }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                                                <i className={`fa fa-${this.props.message.status === 'success' ? 'check-circle' :
                                                                    this.props.message.status === 'danger' ? 'exclamation-triangle' : 'info-circle'}`}
                                                                   style={{ marginRight: '10px', fontSize: '16px' }} />
                                                                <span style={{ flex: 1, fontSize: '14px' }}>{this.props.message.message}</span>
                                                            </div>
                                                        </Alert>
                                                    )}

                                                    <Alert bsStyle="info" style={{
                                                        marginBottom: '25px',
                                                        borderRadius: '8px',
                                                        border: 'none',
                                                        backgroundColor: '#e3f2fd',
                                                        color: '#0d47a1',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                    }}>
                                                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                            <i className="fa fa-shield-alt" style={{
                                                                marginRight: '10px',
                                                                marginTop: '2px',
                                                                fontSize: '16px',
                                                                color: '#1976d2'
                                                            }} />
                                                            <div style={{ flex: 1 }}>
                                                                <strong style={{ fontSize: '15px' }}>Inscription sécurisée</strong>
                                                                <br />
                                                                <span style={{ fontSize: '13px' }}>
                                                                    Créez votre compte professionnel avec validation du numéro d'ordre officiel
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Alert>

                                                    <Row>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Nom & Prénom *
                                                                </ControlLabel>
                                                                <FormControl
                                                                    placeholder="Ex: Dr. Jean Dupont"
                                                                    type="text"
                                                                    onChange={(e) => this.setValue(e.target.value, 'name')}
                                                                    value={this.state.name}
                                                                    required
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        padding: '12px 15px',
                                                                        borderRadius: '8px',
                                                                        border: '2px solid #e0e0e0',
                                                                        transition: 'border-color 0.3s ease',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Téléphone *
                                                                </ControlLabel>
                                                                <FormControl
                                                                    placeholder="Ex: 70 00 00 00"
                                                                    type="tel"
                                                                    onChange={(e) => this.setValue(e.target.value, 'telephone')}
                                                                    value={this.state.telephone}
                                                                    required
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        padding: '12px 15px',
                                                                        borderRadius: '8px',
                                                                        border: '2px solid #e0e0e0',
                                                                        transition: 'border-color 0.3s ease',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Profession *
                                                                </ControlLabel>
                                                                <FormControl
                                                                    placeholder="Ex: Médecin, Pharmacien..."
                                                                    type="text"
                                                                    onChange={(e) => this.setValue(e.target.value, 'profession')}
                                                                    value={this.state.profession}
                                                                    required
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        padding: '12px 15px',
                                                                        borderRadius: '8px',
                                                                        border: '2px solid #e0e0e0',
                                                                        transition: 'border-color 0.3s ease',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Numéro d'ordre *
                                                                </ControlLabel>
                                                                <FormControl
                                                                    placeholder="Ex: R1-0711A"
                                                                    type="text"
                                                                    onChange={(e) => this.setValue(e.target.value, 'numero')}
                                                                    value={this.state.numero}
                                                                    required
                                                                    style={{
                                                                        fontSize: '15px',
                                                                        padding: '12px 15px',
                                                                        borderRadius: '8px',
                                                                        border: '2px solid #e0e0e0',
                                                                        transition: 'border-color 0.3s ease',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>

                                                    <FormGroup style={{ marginBottom: '20px' }}>
                                                        <ControlLabel style={{
                                                            textAlign: 'left',
                                                            display: 'block',
                                                            fontWeight: '600',
                                                            color: '#333',
                                                            marginBottom: '8px',
                                                            fontSize: '14px'
                                                        }}>
                                                            Email *
                                                        </ControlLabel>
                                                        <FormControl
                                                            placeholder="votre.email@exemple.com"
                                                            type="email"
                                                            onChange={(e) => this.setValue(e.target.value, 'email')}
                                                            value={this.state.email}
                                                            required
                                                            style={{
                                                                fontSize: '15px',
                                                                padding: '12px 15px',
                                                                borderRadius: '8px',
                                                                border: '2px solid #e0e0e0',
                                                                transition: 'border-color 0.3s ease',
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                            }}
                                                        />
                                                    </FormGroup>

                                                    <Row>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Mot de passe *
                                                                </ControlLabel>
                                                                <div style={{ position: 'relative' }}>
                                                                    <FormControl
                                                                        placeholder="Minimum 6 caractères"
                                                                        type={showPassword ? "text" : "password"}
                                                                        onChange={(e) => this.setValue(e.target.value, 'password')}
                                                                        value={this.state.password}
                                                                        required
                                                                        style={{
                                                                            fontSize: '15px',
                                                                            padding: '12px 15px',
                                                                            paddingRight: '45px',
                                                                            borderRadius: '8px',
                                                                            border: '2px solid #e0e0e0',
                                                                            transition: 'border-color 0.3s ease',
                                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.togglePasswordVisibility}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '12px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            color: '#666',
                                                                            cursor: 'pointer',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    >
                                                                        <i className={`fa fa-${showPassword ? 'eye-slash' : 'eye'}`} />
                                                                    </button>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs={12} sm={6}>
                                                            <FormGroup style={{ marginBottom: '20px' }}>
                                                                <ControlLabel style={{
                                                                    textAlign: 'left',
                                                                    display: 'block',
                                                                    fontWeight: '600',
                                                                    color: '#333',
                                                                    marginBottom: '8px',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    Confirmer le mot de passe *
                                                                </ControlLabel>
                                                                <div style={{ position: 'relative' }}>
                                                                    <FormControl
                                                                        placeholder="Répétez le mot de passe"
                                                                        type={showConfirmPassword ? "text" : "password"}
                                                                        onChange={(e) => this.setValue(e.target.value, 'confirmPassword')}
                                                                        value={this.state.confirmPassword}
                                                                        required
                                                                        style={{
                                                                            fontSize: '15px',
                                                                            padding: '12px 15px',
                                                                            paddingRight: '45px',
                                                                            borderRadius: '8px',
                                                                            border: '2px solid #e0e0e0',
                                                                            transition: 'border-color 0.3s ease',
                                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.toggleConfirmPasswordVisibility}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '12px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            color: '#666',
                                                                            cursor: 'pointer',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    >
                                                                        <i className={`fa fa-${showConfirmPassword ? 'eye-slash' : 'eye'}`} />
                                                                    </button>
                                                                </div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>

                                                    <p style={{
                                                        margin: '20px 0 0',
                                                        color: '#667085',
                                                        fontSize: '12px',
                                                        lineHeight: 1.6,
                                                        textAlign: 'center'
                                                    }}>
                                                        En vous inscrivant, vous acceptez notre politique de confidentialité et nos conditions d’utilisation.
                                                    </p>
                                                    <div style={{
                                                        textAlign: 'center',
                                                        marginTop: '15px',
                                                        marginBottom: '15px'
                                                    }}>
                                                        <Button
                                                            bsStyle="success"
                                                            block
                                                            type="submit"
                                                            disabled={registrationInProgress || validatingProfessional}
                                                            className="registration-submit-button"
                                                            style={{
                                                                width: '100%',
                                                                padding: '15px 30px',
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                borderRadius: '10px',
                                                                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                                                transition: 'all 0.3s ease'
                                                            }}
                                                        >
                                                            {(registrationInProgress || validatingProfessional) && (
                                                                <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px' }} />
                                                            )}
                                                            {validatingProfessional ? "Validation en cours..." :
                                                             registrationInProgress ? "Création en cours..." : "Créer mon compte"}
                                                        </Button>
                                                    </div>

                                                    <div style={{
                                                        textAlign: 'center',
                                                        marginTop: '25px',
                                                        borderTop: '1px solid #e9ecef',
                                                        paddingTop: '20px'
                                                    }}>
                                                        <p style={{
                                                            color: '#666',
                                                            marginBottom: '12px',
                                                            fontSize: '14px'
                                                        }}>
                                                            Déjà inscrit ?
                                                        </p>
                                                        <Link to="/" style={{
                                                            color: '#1f8ef1',
                                                            textDecoration: 'none',
                                                            fontWeight: '600',
                                                            fontSize: '15px',
                                                            padding: '8px 16px',
                                                            borderRadius: '6px',
                                                            transition: 'background-color 0.3s ease'
                                                        }}>
                                                            <i className="fa fa-sign-in" style={{ marginRight: '8px' }} />
                                                            Se connecter
                                                        </Link>
                                                        <div style={{ marginTop: '14px' }}>
                                                            <Button
                                                                bsStyle="link"
                                                                type="button"
                                                                onClick={() => this.setState({ showPrivacyModal: true })}
                                                            >
                                                                <i className="fa fa-shield-alt" style={{ marginRight: '6px' }} />
                                                                Politique de confidentialité
                                                            </Button>
                                                        </div>
                                                    </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Grid>
                <Modal
                    show={this.state.showPrivacyModal}
                    onHide={() => this.setState({ showPrivacyModal: false })}
                    bsSize="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <i className="fa fa-shield-alt" style={{ marginRight: 10, color: "#1f8ef1" }} />
                            Politique de confidentialité
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: 400, overflowY: "auto" }}>
                        <div style={{ padding: "10px 0" }}>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                LINFOMED veille au respect de la confidentialité sur Internet et est tenu par la loi sur la protection des données à caractère personnel en vigueur dans notre pays.
                            </p>
                            <h4 style={{ color: "#1f8ef1", marginBottom: 15 }}>
                                <i className="fa fa-user" style={{ marginRight: 8 }} /> Utilisation ordinaire
                            </h4>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                En général, après l'inscription ou l'abonnement initial, vous pouvez utiliser cette application sans révéler votre identité ni fournir de renseignements personnels.
                            </p>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                Les informations collectées à l'inscription ou à l'abonnement permettent de créer un compte pour l'utilisateur et de lui fournir les accès.
                            </p>
                            <h4 style={{ color: "#1f8ef1", marginBottom: 15 }}>
                                <i className="fa fa-edit" style={{ marginRight: 8 }} /> Retrait ou modification des informations
                            </h4>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                Le retrait ou la modification des informations personnelles est possible, en revenant sur le formulaire d'inscription ou en prenant contact avec le personnel de LINFOMED.
                            </p>
                            <h4 style={{ color: "#1f8ef1", marginBottom: 15 }}>
                                <i className="fa fa-lock" style={{ marginRight: 8 }} /> Sécurité
                            </h4>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                Les données personnelles confiées ici ne seront en aucun cas vendues ou transmises à des tiers. Toutes les informations confiées par les usagers de l'application sont conservées avec le maximum de sécurité. Elles seront utilisées uniquement de la manière décrite dans les présentes règles de confidentialité. LINFOMED a pris des précautions pour garantir la sécurité des informations archivées dans ses systèmes et les protéger de toute perte, usage abusif, accès illicite, divulgation, altération ou destruction.
                            </p>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                Le personnel ayant accès aux informations personnelles ou associé au traitement de ces données, est tenu de respecter la confidentialité et la protection des données à caractère personnel.
                            </p>
                            <h4 style={{ color: "#1f8ef1", marginBottom: 15 }}>
                                <i className="fa fa-sync" style={{ marginRight: 8 }} /> Modifications
                            </h4>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                Toute modification des présentes règles sera disponible sur le lien de la « politique de confidentialité » de l'application, et publiée sur la page d'accueil du site web de LINFOMED.
                            </p>
                            <div style={{ backgroundColor: "#f8f9fa", padding: 15, borderRadius: 6, marginBottom: 20 }}>
                                <h5 style={{ color: "#495057", marginBottom: 10 }}>
                                    <i className="fa fa-envelope" style={{ marginRight: 8 }} /> Contact
                                </h5>
                                <p style={{ margin: 0, fontSize: 14, color: "#6c757d", lineHeight: 1.8 }}>
                                    Pour toute question ou demande de renseignement sur notre produit, veuillez utiliser les contacts suivants :<br />
                                    <i className="fa fa-map-marker-alt" style={{ marginRight: 6 }} /> Pharmacie GEMME, Tampouy Secteur 16, Ouagadougou<br />
                                    <i className="fa fa-phone" style={{ marginRight: 6 }} /> Tél : (+226) 56 62 44 54 / (+226) 55 12 75 26<br />
                                    <i className="fa fa-whatsapp" style={{ marginRight: 6 }} /> WhatsApp : (+226) 65 06 62 43<br />
                                    <i className="fa fa-envelope" style={{ marginRight: 6 }} /> E-mail : angelinezoungranabe@gmail.com / tlbienvenue3@yahoo.fr
                                </p>
                            </div>
                            <h4 style={{ color: "#1f8ef1", marginBottom: 15 }}>
                                <i className="fa fa-copyright" style={{ marginRight: 8 }} /> Droits d'auteur
                            </h4>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                © Droits d'auteur – LINFOMED, 2022. Tous droits réservés.
                            </p>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                Cette application est protégée par les textes nationaux et/ou internationaux sur les droits de propriété intellectuelle, sur le droit d'auteur et les droits dérivés.
                            </p>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                La mention de noms de fabricants ou de noms commerciaux de médicaments n'implique pas que ces fabricants ou noms commerciaux sont agréés, recommandés, ou préférés par rapport à d'autres, par LINFOMED.
                            </p>
                            <p style={{ marginBottom: 20, lineHeight: 1.6 }}>
                                LINFOMED ne garantit pas que l'information reprise dans cette application est complète ou correcte, et ne pourra en aucun cas être tenue pour responsable de dommages qui pourraient découler de son utilisation.
                            </p>
                            <h4 style={{ color: "#e74c3c", marginBottom: 15 }}>
                                <i className="fa fa-exclamation-triangle" style={{ marginRight: 8 }} /> Avis de non-responsabilité
                            </h4>
                            <p style={{ marginBottom: 15, lineHeight: 1.6 }}>
                                Les informations contenues dans cet outil ne doivent PAS être utilisées comme substitut aux conseils d'un professionnel de santé dûment qualifié, expérimenté et agréé. Les informations fournies ici sont à titre informatif uniquement. Cet outil peut ne pas couvrir toutes les situations réelles d'analyses de prescriptions possibles. Veuillez consulter un médecin ou un pharmacien si vous avez des préoccupations concernant l'utilisation d'un médicament.
                            </p>
                            <div style={{ backgroundColor: "#fff3cd", borderLeft: "4px solid #ffc107", padding: "12px 15px", borderRadius: 4 }}>
                                <p style={{ margin: 0, fontSize: 14, color: "#856404", lineHeight: 1.6 }}>
                                    <strong>Nota Bene :</strong> Bien que nous essayions de fournir des informations exactes et à jour, aucune garantie n'est donnée à cet effet. Veuillez donc vérifier toute information, ou requérir un avis spécialisé en vue d'une utilisation rationnelle du médicament et éviter tout désagrément.
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={() => this.setState({ showPrivacyModal: false })}>
                            <i className="fa fa-check" style={{ marginRight: 6 }} />
                            J'ai compris
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const styles = {
    page: {
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(135deg, #eef4f8 0%, #f8fafc 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "30px 20px",
        boxSizing: "border-box"
    },
    registrationGrid: {
        width: "100%",
        maxWidth: "1080px"
    },
    registrationContainer: {
        width: "100%",
        minHeight: "650px",
        margin: 0,
        border: 0,
        borderRadius: "22px",
        overflow: "hidden",
        display: "flex",
        background: "#fff",
        boxShadow: "0 25px 70px rgba(20, 50, 70, 0.15)",
        transition: "opacity 0.4s ease, transform 0.4s ease"
    },
    imagePanel: {
        width: "38%",
        minHeight: "650px",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative"
    },
    imageOverlay: {
        position: "absolute",
        inset: 0,
        padding: "40px",
        background: "linear-gradient(160deg, rgba(7,45,73,0.88), rgba(23,105,170,0.72), rgba(0,0,0,0.40))",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    },
    logoCircle: {
        width: "65px",
        height: "65px",
        borderRadius: "18px",
        background: "rgba(255,255,255,0.18)",
        border: "1px solid rgba(255,255,255,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "29px"
    },
    imageTitle: {
        fontSize: "40px",
        fontWeight: "800",
        letterSpacing: "1px",
        marginBottom: "12px"
    },
    imageSubtitle: {
        fontSize: "16px",
        lineHeight: "1.7",
        color: "rgba(255,255,255,0.9)"
    },
    imageBottom: {
        display: "flex",
        flexDirection: "column",
        gap: "14px"
    },
    formPanel: {
        flex: 1,
        minWidth: 0,
        background: "#fff",
        display: "flex",
        justifyContent: "center"
    },
    formInner: {
        width: "100%",
        maxWidth: "680px",
        padding: "25px 35px"
    },
    formHeader: {
        padding: "10px 0 20px",
        marginBottom: "15px",
        borderBottom: "1px solid #eaecf0",
        background: "transparent"
    },
    formTitle: {
        margin: "0 0 8px",
        fontSize: "28px",
        fontWeight: "700",
        color: "#172b4d"
    },
    formSubtitle: {
        margin: 0,
        color: "#8492a6",
        fontSize: "14px"
    },
    formBody: {
        padding: 0
    }
};

const mapStateToProps = state => {
    return {
        user: state.user.user,
        profile: state.user.profile,
        loading: state.status.loading,
        message: state.status.message
    }
};

const mapDispatchToProps = dispatch => {
    return {
        registerUser: (userData) => {
            dispatch(registerUser(userData));
        },
        fetchUser: () => {
            dispatch(fetchUser());
        },
        setMessage: message => {
            dispatch(setMessage(message));
        }
    }
};

Registration.propTypes = {
    loading: PropTypes.bool,
    message: PropTypes.object,
    showNotification: PropTypes.func,
    setMessage: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Registration);